<template>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div v-for="card in cards" :key="card.title"
            class="rounded-xl transition p-5 bg-gradient-to-r from-indigo-100 dark:from-gray-800 to-indigo-200 dark:to-gray-700">
            <div class="flex items-center gap-2 mb-2">
                <span class="text-3xl">{{ card.icon }}</span>
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white">{{ card.title }}</h3>
            </div>
            <p class="text-4xl font-bold text-indigo-600">{{ card.count }}</p>
            <p class="text-sm mt-1 text-secondary-text dark:text-gray-300">{{ card.description }}</p>
        </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-4 ">
        <OrderChart />
        <OrderTable />
    </div>
</template>

<script>
import { getApi } from '@/services/api'
import OrderChart from '@/components/OrderChart.vue'
import OrderTable from '@/components/OrderTable.vue'

export default {
    name: 'HomePage',
    components: {
        OrderChart,
        OrderTable
    },
    data() {
        return {
            totalOrderCount: 0,
            totalDriverCount: 0,
            totalDealerCount: 0,
            activeDealerCount: 0,
            totalPendingApproval: 0,
            newDealerCount: 0,
        };
    },
    computed: {
        cards() {
            return [
                
                {
                    icon: '🚚',
                    title: 'Aktif Sürücü Sayısı',
                    count: this.totalDriverCount,
                    description: 'Anlık aktif',
                },
                {
                    icon: '🏢',
                    title: 'Toplam Bayi Sayısı',
                    count: this.totalDealerCount,
                    description: this.getDealerDescription(),

                },
                {
                    icon: '⏳',
                    title: 'Bekleyen Onaylar',
                    count: this.totalPendingApproval,
                    description: this.getPendingDescription(),
                },
            ]
        }
    },
    async mounted() {
        try {
            const counts = await getApi('/dashboard/counts');
            this.totalOrderCount = counts.total_orders || 0;
            this.totalDealerCount = counts.total_dealers || 0;
            this.totalDriverCount = counts.total_active_drivers || 0;
            this.totalPendingApproval = counts.total_pending_approvals || 0;
        } catch (err) {
            console.error("Dashboard verileri alınamadı:", err);
        }
    },

    methods: {
        goToPage(path) {
            this.$router.push(path);
        },

        getOrderDescription() {
            if (this.totalOrderCount > 1000) {
                return 'Yüksek sipariş yoğunluğu';
            } else if (this.totalOrderCount > 0) {
                return 'Siparişler aktif';
            } else {
                return 'Hiç sipariş yok';
            }
        },

        getPendingDescription() {
            if (this.totalPendingApproval > 10) {
                return 'Çok sayıda bekleyen onay var';
            } else if (this.totalPendingApproval > 0) {
                return 'Az sayıda onay bekliyor';
            } else {
                return 'Tüm teslimatlar onaylı';
            }
        },

        getDealerDescription() {
            if (this.totalDealerCount > 100) {
                return 'Geniş bayi ağı';
            } else if (this.totalDealerCount > 50) {
                return 'Orta büyüklükte bayi ağı';
            } else if (this.totalDealerCount > 0) {
                return 'Yeni büyüyen bayi ağı';
            } else {
                return 'Henüz bayi bulunmuyor';
            }
        }


    },
};
</script>